<!-- 
    描述：费用管理
    时间：2021-07-13
    Created by zl
-->
<template>
	<div class="Fee-layout filter-layout">
		<div class="filter-box mb10">
			<el-form v-show="searchToggle"
					 ref="feeForm"
					 :model="feeForm"
					 size="small"
					 label-width="100px">
				<el-row>
					<el-col :span="6">
						<el-form-item label="工程项目名称"
									  prop="projectName">
							<el-input v-model="feeForm.projectName"
									  placeholder="请输入工程项目名称"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="标题"
									  prop="title">
							<el-input v-model="feeForm.title"
									  placeholder="请输入标题"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="申请人"
									  prop="applyUser">
							<el-input v-model="feeForm.applyUser"
									  placeholder="请输入申请人"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="申请单位"
									  prop="unitName">
							<el-select v-model="feeForm.unitName"
									   filterable
									   clearable
									   placeholder="请选择申请单位">
								<el-option v-for="item in applyUnit"
										   :key="item.id + 'unitName'"
										   :label="item.sname"
										   :value="item.sname">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="申请时间"
									  prop="time">
							<el-date-picker type="daterange"
											v-model="feeForm.time"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd HH:ss:mm"
											:default-time="['00:00:00', '23:59:59']"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											range-separator="-"
											@change="timeChange"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="审批时间"
									  prop="date">
							<el-date-picker type="daterange"
											v-model="feeForm.date"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd HH:ss:mm"
											:default-time="['00:00:00', '23:59:59']"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											range-separator="-"
											@change="dataChange"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="合同依据"
									  prop="contractName">
							<el-input v-model="feeForm.contractName"
									  placeholder="请输入合同依据"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="建设单位"
									  prop="buildName">
							<el-select v-model="feeForm.buildName"
									   filterable
									   clearable
									   placeholder="请选择建设单位">
								<el-option v-for="item in ownerUnit"
										   :key="item.id + 'buildName'"
										   :label="item.sname"
										   :value="item.sname">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="收款单位"
									  prop="sname">
							<el-select v-model="feeForm.sname"
									   filterable
									   clearable
									   placeholder="请选择收款单位">
								<el-option v-for="item in payeeUnit"
										   :key="item.id + 'sname'"
										   :label="item.sname"
										   :value="item.sname">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="付款状态"
									  prop="status">
							<el-select v-model="feeForm.status"
									   clearable
									   placeholder="请选择付款状态">
								<el-option v-for="(item, index) in statusList"
										   :key="index"
										   :label="item.sname"
										   :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12"
							class="text-right">
						<el-form-item size="small">
							<el-button type="primary"
									   icon="el-icon-search"
									   @click="searchForm">查询</el-button>
							<el-button @click="resetForm"
									   icon="el-icon-refresh">重置</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<!-- 筛选折叠按钮 -->
			<div class="control-btn"
				 @click="searchToggle = !searchToggle">
				{{ searchToggle ? '点击收起' : '筛选' }}
				<svg-icon :icon-class="searchToggle ? 'pack-up' : 'pack-down'"
						  class="c-icon ml5"></svg-icon>
			</div>
		</div>
		<div class="filter-content primary-layout">
			<div class="primary-header">
				<div class="left-text"></div>
				<div class="btnGroups">
					<el-button-group class="mr10">
						<el-button size="small"
								   @click="searchData(1)">当月</el-button>
						<el-button size="small"
								   @click="searchData(2)">当季</el-button>
						<el-button size="small"
								   @click="searchData(3)">近半年</el-button>
						<el-button size="small"
								   @click="searchData(4)">近一年</el-button>
					</el-button-group>
					<el-button type="primary"
							   size="small"
							   @click="doFilter">列过滤</el-button>
				</div>
			</div>
			<div class="primary-content">
				<div class="w-table-layout w-table-page">
					<div class="w-table-content">
						<vxe-table align="center"
								   auto-resize
								   ref="feeTable"
								   border
								   :data="tableObj.table"
								   key="10002"
								   height="100%"
								   highlight-current-row
								   highlight-hover-row
								   :loading="tableObj.loading"
								   show-overflow="tooltip"
								   show-header-overflow="tooltip">
							<vxe-table-column type="seq"
											  title="序号"
											  width="60"></vxe-table-column>
							<vxe-table-column field="projectName"
											  title="工程项目名称"
											  min-width="150"
											  header-align="center"
											  align="left"></vxe-table-column>
							<vxe-table-column field="proTypeName"
											  title="项目类型"
											  min-width="130"
											  :visible="false"
											  header-align="center"
											  align="left"></vxe-table-column>
							<vxe-table-column field="title"
											  title="标题"
											  min-width="150"
											  header-align="center"
											  align="left"></vxe-table-column>
							<vxe-table-column field="buildName"
											  title="建设单位"
											  min-width="150"
											  :visible="false"
											  header-align="center"
											  align="left"></vxe-table-column>
							<vxe-table-column field="taskName"
											  title="关联任务"
											  min-width="150"
											  :visible="false"
											  header-align="center"
											  align="left"></vxe-table-column>
							<vxe-table-column field="sname"
											  title="收款单位"
											  min-width="150"
											  :visible="false"
											  header-align="center"
											  align="left"></vxe-table-column>
							<vxe-table-column field="applyAmount"
											  title="申请金额（元）"
											  width="120"
											  header-align="center"
											  align="right"></vxe-table-column>
							<vxe-table-column field="approvalAmount"
											  title="审核金额（元）"
											  width="120"
											  header-align="center"
											  align="right">
							</vxe-table-column>
							<vxe-table-column field="payAmount"
											  title="支付金额（元）"
											  width="120"
											  header-align="center"
											  align="right"></vxe-table-column>
							<vxe-table-column field="applyUser"
											  title="申请人"
											  width="100"></vxe-table-column>
							<vxe-table-column field="unitName"
											  title="申请单位"
											  min-width="150"
											  header-align="center"
											  align="left"></vxe-table-column>
							<vxe-table-column field="createDate"
											  title="申请时间"
											  width="110">
								<template #default="{ row }">
									<el-tooltip effect="dark"
												:content="row.createDate"
												placement="top">
										<span class="vxe-cell--label"
											  v-if="row.createDate">
											{{ row.createDate.substr(0, 11) }}
										</span>
									</el-tooltip>
								</template>
							</vxe-table-column>
							<vxe-table-column field="approvalDate"
											  title="审批日期"
											  width="110">
								<template #default="{ row }">
									<el-tooltip effect="dark"
												:content="row.approvalDate"
												placement="top">
										<span class="vxe-cell--label"
											  v-if="row.approvalDate">
											{{ row.approvalDate.substr(0, 11) }}
										</span>
									</el-tooltip>
								</template>
							</vxe-table-column>
							<vxe-table-column field="contractName"
											  title="合同依据"
											  min-width="150"
											  header-align="center"
											  align="left">
								<template #default="{ row }">
									<span class="blue-text"
										  @click="viewContract(row)">
										{{ row.contractName }}
									</span>
								</template>
							</vxe-table-column>
							<vxe-table-column field="contractTypeName"
											  title="合同类型"
											  min-width="150"
											  header-align="center"
											  align="left"></vxe-table-column>
							<vxe-table-column field="hasInvoice"
											  title="发票"
											  width="60">
								<template #default="{ row }">
									{{ row.hasInvoice ? '有' : '无' }}
								</template>
							</vxe-table-column>
							<vxe-table-column field="statusName"
											  title="当前状态"
											  width="120">
								<template #default="{ row }">
									<span :class="className(row.status)">
										<span v-if="row.status == '1001026016'">
											待付款
										</span>
										<span v-else>{{ row.statusName }}</span>
									</span>
								</template>
							</vxe-table-column>
							<vxe-table-column title="操作"
											  width="120">
								<template #default="{ row }">
									<template v-if="row.status == '1001026016' || row.status == '1001026017'">
										<el-button type="success"
												   class="table-btn"
												   plain
												   round
												   v-if="roleBtns.includes('pay')"
												   icon="el-icon-edit-outline"
												   @click="doClick('pay', row)">付款登记</el-button>
									</template>
									<template v-else>
										<el-button type="primary"
												   class="table-btn"
												   plain
												   round
												   v-if="roleBtns.includes('view')"
												   @click="doClick('view', row)">
											<svg-icon icon-class="form-look"></svg-icon> 查看
										</el-button>
									</template>
								</template>
							</vxe-table-column>
						</vxe-table>
					</div>
					<div class="w-table-pager">
						<vxe-pager align="center"
								   :page-size="tableObj.size"
								   :current-page="tableObj.current"
								   :total="tableObj.total"
								   :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
								   @page-change="handleCurrentChange"></vxe-pager>
					</div>
				</div>
			</div>
		</div>

		<!-- 付款登记/查看 -->
		<el-dialog title="费用划转"
				   :visible.sync="dialogObj.show"
				   width="1200px"
				   :close-on-click-modal="false"
				   center
				   top="5vh"
				   custom-class="fee-dialog"
				   :before-close="dialogBeforeClose">
			<FeeDialog ref="payDialog"
					   v-if="dialogObj.show"
					   :type="dialogObj.type"
					   :selectObj="selectObj"
					   :statusList="statusList"
					   @btnLoding="acceptDeal"></FeeDialog>
			<div slot="footer"
				 class="footer"
				 v-if="dialogObj.type != 'view'">
				<el-button class="btn"
						   @click="dialogBeforeClose">取 消</el-button>
				<el-button class="btn btn-blue"
						   type="primary"
						   :loading="dialogObj.loading"
						   @click="doPay">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 查看合同 -->
		<el-dialog title="查看合同"
				   :visible.sync="contractShow"
				   :close-on-click-modal="false"
				   center
				   append-to-body
				   top="6vh"
				   width="1200px"
				   @closed="handleCloseDialog">
			<ContractView v-if="contractShow"
						  class="h600"
						  doType="view"
						  :projectName="contractObj.projectName"
						  :contractObj="contractObj"></ContractView>
		</el-dialog>

		<!-- 列过滤 -->
		<ColumnFilter v-if="showFilter"
					  ref="filterColumn"
					  :filterColumns="filterColumns"
					  @onFilter="onFilter"></ColumnFilter>
	</div>
</template>
<script>
import FeeDialog from '@/views/FeeManagement/FeeDialog'
import { mapState } from 'vuex'
import { getFeePages, pageSelectParam } from 'api/approval/approval'
import ContractView from '@/views/FeeManagement/ContractView'
import ColumnFilter from '@/views/Common/ColumnFilter'
import { getStatusStyle } from 'utils/tools.js'
export default {
	name: 'FeeIndex',
	components: {
		FeeDialog,
		ContractView,
		ColumnFilter,
	},
	props: {},
	data() {
		return {
			searchToggle: true,
			feeForm: {
				projectName: '', //项目名称
				title: '', //标题
				applyUser: '', //申请人
				unitName: '', //申请单位
				time: '', //申请时间
				startDate: '', //开始日期
				endDate: '', //结束日期
				date: '', //审批时间
				approvalStartDate: '', //审批开始时间
				approvalEndDate: '', //审批开始时间
				contractName: '', //合同依据
				buildName: '', //建设单位
				accountName: '', //收款单位
				status: '', //当前状态
				searchType: '',
			},
			// 弹窗对象
			dialogObj: {
				type: '',
				show: false,
				loading: false,
			},
			// 表格对象
			tableObj: {
				table: [],
				size: 10,
				current: 1,
				total: 0,
				loading: false,
			},
			selectObj: {},
			contractList: [], //合同列表
			contractShow: false, //查看合同显隐
			contractObj: {}, //合同对象
			filterColumns: [
				{
					title: '',
					checkAll: false,
					columns: [],
				},
			], //所有的列
			showFilter: false,
			payeeUnit: [], //收款单位
			ownerUnit: [], //建设单位
			applyUnit: [], //申请单位
			typeNum: '',
		}
	},
	created() {
		// 获取审计费用数据
		this.getFeeData(true)
	},
	mounted() {
		setTimeout(() => {
			let tableColumn = this.$refs.feeTable.getTableColumn()
			this.filterColumns[0].columns = tableColumn.collectColumn
			this.filterColumns[0].columns[
				this.filterColumns[0].columns.length - 1
			].noFilter = true
		}, 1000)
	},
	methods: {
		// 点击列过滤
		doFilter() {
			this.showFilter = true
			setTimeout(() => {
				this.$refs.filterColumn.dialogObj.visible = true
			}, 200)
		},

		// 确认列过滤
		onFilter(arr) {
			this.tableObj.loading = true
			if (this.$refs.feeTable) {
				// 确定赋值
				this.$set(this, 'filterColumns', arr)

				this.$refs.feeTable.refreshColumn()
				this.tableObj.loading = false
				return
			}
			this.tableObj.loading = false
		},

		//列表查询条件赋值
		pageSelectParam() {
			pageSelectParam().then((res) => {
				// console.log(res)
				this.payeeUnit = res.data.payeeUnit
				this.ownerUnit = res.data.ownerUnit
				this.applyUnit = res.data.applyUnit
			})
		},

		// 获取审计费用数据
		getFeeData(need) {
			let params = this.$utils.clone(this.feeForm, true)
			params.size = this.tableObj.size
			params.current = this.tableObj.current
			params.searchType = this.typeNum
			delete params.time
			delete params.date
			this.tableObj.loading = true
			getFeePages(params)
				.then((res) => {
					this.tableObj.table = res.data.records
					this.tableObj.total = parseInt(res.data.total)
					this.tableObj.loading = false
					if (need) {
						//列表查询条件赋值
						this.pageSelectParam()
					}
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},

		// 按钮点击事件
		doClick(type, data) {
			this.dialogObj.type = type
			this.dialogObj.show = true
			this.selectObj = data
		},

		// 付款登记确认
		doPay() {
			let payRef = this.$refs.payDialog
			this.dialogObj.loading = true
			payRef.doSave()
		},

		// 申请时间change事件
		timeChange(data) {
			this.feeForm.startDate = data[0]
			this.feeForm.endDate = data[1]
		},

		// 申请时间change事件
		dataChange(data) {
			this.feeForm.approvalStartDate = data[0]
			this.feeForm.approvalEndDate = data[1]
		},

		//条件搜索事件
		searchForm() {
			this.tableObj.current = 1
			this.getFeeData()
		},

		// 重置表单
		resetForm() {
			this.$refs['feeForm'].resetFields()
			this.feeForm.startDate = ''
			this.feeForm.endDate = ''
			this.feeForm.approvalStartDate = ''
			this.feeForm.approvalEndDate = ''
			this.typeNum = ''
			this.searchForm()
		},

		// 分页处理
		handleCurrentChange({ currentPage, pageSize }) {
			this.tableObj.size = pageSize
			this.tableObj.current = currentPage
			this.getFeeData()
		},

		// dialogBeforeClose
		dialogBeforeClose() {
			this.selectObj = {}
			this.dialogObj.show = false
		},

		// 接收
		acceptDeal(data, type) {
			this.dialogObj.loading = data
			if (type == 'success') {
				this.selectObj = {}
				this.getFeeData()
				this.dialogObj.show = false
			}
		},

		// 处理类名
		className(data) {
			let msg = getStatusStyle(data)
			return msg
		},

		// 按钮控制
		dealShow(data) {
			let status = data == '1001026016' || data == '1001026017'
			return status
		},

		// 按钮控制
		dealShow1(data) {
			let status1 = data == '1001026018' || data == '1001026019'
			return status1
		},

		// 查看合同依据
		viewContract(data) {
			this.contractObj = this.$utils.clone(data)
			this.contractObj.id = this.contractObj.contractId
			this.contractShow = true
			this.$router.push({
				query: {
					type: 'view',
				},
			})
		},

		// 关闭合同弹窗
		handleCloseDialog() {
			this.$router.push({
				query: {},
			})
		},

		// 分类搜索
		searchData(data) {
			this.typeNum = data
			this.getFeeData()
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		// 状态
		statusList() {
			let arr = ['1001026016', '1001026017', '1001026018', '1001026019']
			let list = []
			list = this.projectDict.xtggzt.filter((x) => {
				if (arr.includes(x.value)) {
					return x
				}
			})
			return list
		},
	},
}
</script>
<style lang='less' scoped>
.Fee-layout {
	padding: 30px 20px 10px 20px;
	.btn {
		padding: 0 50px !important;
	}
	.footer {
		padding-top: 10px;
		border-top: 1px solid #eee;
	}
}
.h600 {
	height: 600px;
}
</style>

<style lang="less">
.fee-dialog {
	.el-dialog__body {
		max-height: 700px !important;
	}
}
</style>
